import { getScalesReadingWsHandler } from './scalesRedingWsHandler'
import { SHOULD_SHOW_DEBUG } from '../constants'

export function init(): void {
  if (!SHOULD_SHOW_DEBUG) {
    window.console.debug = () => {}
  } else {
    console.group('Env')
    console.debug(JSON.stringify(process.env, null, 2))
    console.groupEnd()
  }

  console.debug('ws handler init')
  const wsHandler = getScalesReadingWsHandler()

  wsHandler
    .connect()
    .then(() => {
      console.debug(`ws handler init: connected`)
    })
    .catch((e) => {
      console.debug(`ws handler init: error: ${e}`)
    })
}
